import { useMutation, useQueryClient } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';

interface SubmitPracticeSetParams {
  practiceSetId: string;
}

const useSubmitPracticeSet = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ practiceSetId }: SubmitPracticeSetParams) => {
      const { data, error } = await supabaseClient.functions.invoke('submit-practice-set', {
        body: {
          practice_set_id: practiceSetId,
        },
      });

      if (error) {
        console.error('Failed to submit practice set:', error);
        throw error;
      }

      return data;
    },
    onSuccess: (_, variables) => {
      // Invalidate practice set query to refetch with graded answers
      queryClient.invalidateQueries({ queryKey: ['practice_set', variables.practiceSetId] });
      queryClient.invalidateQueries({ queryKey: ['practice_attempts'] });
    },
  });
};

export default useSubmitPracticeSet;
